module.exports = __webpack_public_path__ + "./favicons/ms-icon-150x150.png";